
import Vue from "vue";
import { mapActions } from "vuex";

import NoDataAvailable from "@/components/NoDataAvailable.vue";
import TrHealthMonitoringGraph from "./TrHealthMonitoringGraph.vue";
import TrAdvanceAnalysisGraph from "./TrAdvanceAnalysisGraph.vue";
import TrCorrelationGraph from "./TrCorrelationGraph.vue";
import McaCurrentSpectrum from "./McaCurrentSpectrum.vue";
import McaTimeSeries from "./McaTimeSeries.vue";
import EvsModelChart from "./EvsModelChart.vue";
import VcaTrendSignal from "./VcaTrendSignal.vue";
import VcaCurrentAnalysis from "./VcaCurrentAnalysis.vue";
import remainingLife from "./remainingLife.vue";
import McaPetternRecog from "./McaPetternRecog.vue";
import McaCurrentSpectrum3D from "./McaCurrentSpectrum3D.vue";
import { CurrentSpectrumTabEnum } from "../../enums/CurrentSpectrumTabEnum";
import DischargeMca from "../details/DischargeMca.vue";

// Fallback so the render function can never throw on a missing/half-loaded tab. A throw here is
// unrecoverable: Vue 2 aborts the render before the watcher collects any dependency, so the
// component is silently detached from the store and stays blank until it is destroyed.
const EMPTY_TAB = { id: 0, name: "", key: 0, groupCode: "" };

export default Vue.extend({
  name: "GraphTabGroup",
  components: {
    TrHealthMonitoringGraph,
    TrAdvanceAnalysisGraph,
    TrCorrelationGraph,
    NoDataAvailable,
    McaCurrentSpectrum,
    McaCurrentSpectrum3D,
    McaTimeSeries,
    EvsModelChart,
    VcaTrendSignal,
    VcaCurrentAnalysis,
    remainingLife,
    McaPetternRecog,
    DischargeMca,
  },
  data() {
    const primaryNameLists = [
      "Health Monitoring",
      "Advance analysis",
      "Correlation (Anomaly)",
      "Current Spectrum",
      "Time Series Detail",
      "Frequency Detail",
      "Current Analysis",
      "Trend Signal",
      "Trend",
    ];

    const currentSpectrum2D3DTabList = [CurrentSpectrumTabEnum.Spectrum2D, CurrentSpectrumTabEnum.Spectrum3D];

    return {
      primaryNameLists,
      currentSpectrum2D3DTabList,
      currentSpectrumTab: CurrentSpectrumTabEnum.Spectrum2D,
      currentSpectrumTabEnum: CurrentSpectrumTabEnum,
    };
  },
  computed: {
    modelType() {
      return this.$store.state.model.equipmentModelType.id;
    },
    primary() {
      return this.$store.state.graphInformationTab.is_primary_tab ?? EMPTY_TAB;
    },
    secondary() {
      return this.$store.state.graphInformationTab.is_secondary_tab ?? EMPTY_TAB;
    },
    primaryTab() {
      return this.$store.state.graphInformationTabGroupData.graph_primary_tab ?? [];
    },
    secondaryTab() {
      return this.$store.state.graphInformationTabGroupData.graph_secondary_tab ?? [];
    },
    modelPrimary: {
      get() {
        return this.primary.key ?? 0;
      },
      set(value) {
        this.setGraphInformationTabGroup({
          ...this.$store.state.graphInformationTab,
          is_primary_tab: { ...this.$store.state.graphInformationTab.is_primary_tab, key: value },
        });
      },
    },
    modelSecondary: {
      get() {
        return this.secondary.key ?? 0;
      },
      set(value: number) {
        const groupCode = this.secondaryTab[value]?.groupCode;
        this.setGraphInformationTabGroup({
          ...this.$store.state.graphInformationTab,
          is_secondary_tab: { ...this.$store.state.graphInformationTab.is_secondary_tab, key: value, groupCode },
        });
      },
    },
  },
  methods: {
    ...mapActions(["setGraphInformationTabGroup", "getGraphInformationSecondaryTabGroupData"]),
    async onChangePrimaryTab(event: any) {
      const { id, name, key } = event;

      this.setGraphInformationTabGroup({
        ...this.$store.state.graphInformationTab,
        is_primary_tab: { id, name, key },
      });
      await this.getGraphInformationSecondaryTabGroupData();
    },
    onChangeSecondaryTab(event: any) {
      const { id, name, key, groupCode } = event;

      this.setGraphInformationTabGroup({
        ...this.$store.state.graphInformationTab,
        is_secondary_tab: { id, name, key, groupCode },
      });
    },
    onChangeSpectrum2D3DTab(event: CurrentSpectrumTabEnum) {
      this.currentSpectrumTab = event;
    },
  },
});
